export default "__VITE_ASSET__CUyY6B2Z__"